import { useSearchParams } from "react-router-dom";
import { Package, Monitor, AppWindow, Terminal } from "lucide-react";
import PatchableAppsTable from "./PatchableAppsTable";
import PatchableOSTable from "./PatchableOSTable";
import Applications from "../Applications";
import CustomScripts from "../Settings/CustomScripts";

export default function PatchMain() {
    const [searchParams, setSearchParams] = useSearchParams();

    // Read from URL, default to 'all_apps' if not set or invalid
    const rawTab = searchParams.get("tab");
    const activeTab = rawTab === "os" ? "os" : rawTab === "all_apps" ? "all_apps" : rawTab === "scripts" ? "scripts" : "application";

    // Update URL when switching tabs
    const handleTabChange = (tab: 'all_apps' | 'application' | 'os' | 'scripts') => {
        setSearchParams({ tab });
    };

    return (
        <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200 w-full max-w-full overflow-x-hidden">
            {/* Header / Tabs Navigation */}
            <div className="flex items-center justify-between bg-white dark:bg-gray-900/90 backdrop-blur-md p-2 sm:p-2.5 border-b border-gray-200 dark:border-gray-800 shadow-sm sticky top-0 z-20 transition-colors duration-200 max-w-full min-w-0">

                {/* Tabs */}
                <div className="flex items-center overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden bg-gray-100 dark:bg-gray-800/90 p-1 border rounded-lg border-gray-200 dark:border-gray-700/80 max-w-full gap-1">
                    <button
                        onClick={() => handleTabChange('all_apps')}
                        className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-[10px] sm:text-[11px] font-bold uppercase tracking-wider sm:tracking-widest transition-all duration-200 border whitespace-nowrap shrink-0 ${activeTab === 'all_apps'
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-orange-600 dark:text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/60 dark:hover:bg-gray-700/50'
                            }`}
                    >
                        <AppWindow size={14} className="shrink-0" />
                        <span>All Application</span>
                    </button>
                    <button
                        onClick={() => handleTabChange('application')}
                        className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-[10px] sm:text-[11px] font-bold uppercase tracking-wider sm:tracking-widest transition-all duration-200 border whitespace-nowrap shrink-0 ${activeTab === 'application'
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-orange-600 dark:text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/60 dark:hover:bg-gray-700/50'
                            }`}
                    >
                        <Package size={14} className="shrink-0" />
                        <span>Patchable Application</span>
                    </button>
                    <button
                        onClick={() => handleTabChange('os')}
                        className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-[10px] sm:text-[11px] font-bold uppercase tracking-wider sm:tracking-widest transition-all duration-200 border whitespace-nowrap shrink-0 ${activeTab === 'os'
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-orange-600 dark:text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/60 dark:hover:bg-gray-700/50'
                            }`}
                    >
                        <Monitor size={14} className="shrink-0" />
                        <span>OS Patching</span>
                    </button>
                    <button
                        onClick={() => handleTabChange('scripts')}
                        className={`flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-md text-[10px] sm:text-[11px] font-bold uppercase tracking-wider sm:tracking-widest transition-all duration-200 border whitespace-nowrap shrink-0 ${activeTab === 'scripts'
                            ? 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-600 text-orange-600 dark:text-orange-400 shadow-sm'
                            : 'border-transparent text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white hover:bg-white/60 dark:hover:bg-gray-700/50'
                            }`}
                    >
                        <Terminal size={14} className="shrink-0" />
                        <span>Scripts</span>
                    </button>
                </div>

                {/* Jobs Button */}

            </div>

            {/* Tab Content */}
            <div className="flex-1 px-3 pb-20">
                {activeTab === 'all_apps' && <Applications />}
                {activeTab === 'application' && <PatchableAppsTable />}
                {activeTab === 'os' && <PatchableOSTable />}
                {activeTab === 'scripts' && <CustomScripts />}
            </div>
        </div>
    );
}